import { Psy } from "../Psy-app/Psy-app.js";
const psy = new Psy();
window.psy = psy;

// POPUP
$('.popup__close, .popup__cancel').click(function(e){
	$('body').removeClass('no-scroll');
	$(this).closest('.popup').removeClass('active');
});

$('.popup').click(function(e) {
	var callbackPopup = $(".popup__container")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(this).removeClass('active');
		$('body').removeClass('no-scroll');
	};
});

$('.psy-app__forget-password').click(function(){
	$('body').addClass('no-scroll');
	$('.popup-password').addClass('active');
});

$('.authors-choice__new').click(function(){
	$('body').addClass('no-scroll');
	$('.popup-new-author').addClass('active');
	$('.popup-new-author #add-author-type').val($(this).val());
});

$('.authors-choice__search').click(function(){
	$('body').addClass('no-scroll');
	$('.popup-search-author').addClass('active');
	$('.popup-search-author #search-author-type').val($(this).val());

});

$('.psy-app__file-input').change(function(){
	psy.captureFiles(this);
});
$('.psy-app__link-button').click(function(){
	psy.addLink(this);
});

/*$('.psy-app__selection-add').click(function(){
	$('body').removeClass('no-scroll');
	$('.popup-search-author').removeClass('active');
});*/

// Steps nav
$(".psy-app__tab:not(:first-of-type)").hide();
$(".psy-app__nav-item:first-of-type .psy-app__nav-btn").addClass("active");
$(".psy-app__nav-btn").click(function() {
	if(!$(this).hasClass('active')) {
		let currStep = $('.psy-app__nav-btn.active').closest('li').index() + 1;
		psy.save($('#app_step_' + currStep));

		$(this).parent(".psy-app__nav-item").siblings().children(".psy-app__nav-btn").removeClass("active");
		$(this).addClass("active");
		$(this).parents(".psy-app__tabs").find(".psy-app__tab").hide();
		$(".psy-app__tab").eq($(this).index(".psy-app__nav-btn")).fadeIn();
	}
});

$(".psy-app__step-nav-btn--next").click(function() {
	psy.save($(this).closest('.psy-app__step'));
	$(this).closest(".psy-app__tab").hide();
	$(this).closest(".psy-app__tab").next(".psy-app__tab").fadeIn();
	$(".psy-app__nav-btn").removeClass("active");
	$(".psy-app__nav-btn").eq($(this).index(".psy-app__step-nav-btn--next") + 1).addClass("active");
	$('html, body').animate( { scrollTop: 0 }, 400 );
});

$(".psy-app__step-nav-btn--prev").click(function() {
	psy.save($(this).closest('.psy-app__step'));
	$(this).closest(".psy-app__tab").hide();
	$(this).closest(".psy-app__tab").prev(".psy-app__tab").fadeIn();
	$(".psy-app__nav-btn").removeClass("active");
	$(".psy-app__nav-btn").eq($(this).index(".psy-app__step-nav-btn--prev")).addClass("active");
	$('html, body').animate( { scrollTop: 0 }, 400 );
});
$('.psy-app__radio-input[name=slt_nominations_1]').change(function(){
	let nom = $('.psy-app__radio-input[name=slt_nominations_1]:checked').val();
	$('#psy-app__note-type p').removeClass('active');
	$('#psy-app__note-type p[data-nom=' + nom + ']').addClass('active');
});

$('.author-new__photo-input').change(function(){
	psy.loadPhoto(this);
});


// Document clicks
$(document).click(function(e) {
	if (window.matchMedia("(max-width: 1023px)").matches && $('.psy-app__nomination-additional').is(":visible")) {
		var callbackPopup = $(".psy-app__nomination-additional, .psy-app__nomination-info")
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$('.psy-app__nomination-additional').fadeOut();
		};
	}
});

// resize
$(window).resize(function() {
	if (window.matchMedia("(min-width: 1024px)").matches && $('.psy-app__nomination-additional').is(":visible")) {
		$('.psy-app__nomination-additional').removeAttr("style");
	}

	if (window.matchMedia("(max-width: 1023px)").matches && $('.psy-app__nominations-additional').is(":visible")) {
		$(".psy-app__nominations-info").removeAttr("style");
		$('.psy-app__nominations-additional').removeAttr("style");
	}

	// textarea autoheight
	$(".psy-app__textarea--autoheight").each(function() {
		this.style.height = 'auto';
		this.style.height = (this.scrollHeight) + 1 + 'px';
	});
});

// nominations
$('.psy-app__nomination-info').click(function(){
	if (window.matchMedia("(max-width: 1023px)").matches) {
		$('.psy-app__nomination-info').not(this).closest(".psy-app__nomination-item").find(".psy-app__nomination-additional").fadeOut();
		$(this).closest(".psy-app__nomination-item").find(".psy-app__nomination-additional").fadeToggle();
	}

	if (window.matchMedia("(min-width: 1024px)").matches) {
		$(".psy-app__nominations-info").hide();
		$(".psy-app__nominations-additional").not($(this).index(".psy-app__nomination-info")).hide();
		$(".psy-app__nominations-additional").eq($(this).index(".psy-app__nomination-info")).show();
	}
});

$('.psy-app__nomination-additional-close').click(function(){
	$(this).closest(".psy-app__nomination-additional").fadeOut();
});

$('.psy-app__nominations-additional-close').click(function(){
	$(this).closest(".psy-app__nominations-additional").hide();
	$(".psy-app__nominations-info").show();
});

// fold
$('.psy-app__fold-toggler').click(function(){
	$(this).siblings(".psy-app__fold-hidden").slideToggle();
});

// pay
$('.psy-app__pay-btn').click(function(){
	$(".psy-app__nav-btn").removeClass("active");
	$(".psy-app__nav-btn").addClass("ready");
	$('.psy-app__hide').hide();
	$('.psy-app__pay-success').fadeIn();
});

// essay choice
$(".psy-app__essay-choice").change(function(){
	if($(".psy-app__essay-choice--cke").is(":checked")) {
		$(".psy-app__essay-file").hide();
		$(".psy-app__essay-cke").fadeIn();
	}

	if($(".psy-app__essay-choice--file").is(":checked")) {
		$(".psy-app__essay-cke").hide();
		$(".psy-app__essay-file").fadeIn();
	}
});

// textarea autoheight
$(".psy-app__textarea--autoheight").each(function() {
	this.style.height = 'auto';
	this.style.height = (this.scrollHeight) + 1 + 'px';
});

$('.psy-app__textarea--autoheight').on('input', function(){
	this.style.height = 'auto';
	this.style.height = (this.scrollHeight) + 1 + 'px';
});

// draft
$('.psy-app__draft-btn').click(function(){
	//$(this).children(".psy-app__draft-saved").fadeIn().delay(1000).fadeOut(200);
	psy.save($(this).closest('.psy-app__step'));
});

// save on filename focus change
$('.psy-app__input_autosave').focusout(function(){
	// console.log("focus event")
	psy.save($(this).closest('.psy-app__step'));
});

// start toggler
$('.psy-start__block-toggler').click(function(){
	$(this).siblings(".psy-start__block-content").slideToggle();
});

const editorConfig = {
	toolbar: {
		items: ['bold', 'italic', 'bulletedList', 'numberedList', 'undo', 'redo', '|', 'heading'],
		shouldNotGroupWhenFull: false
	},
	heading: {
		options: [
			{
				model: 'paragraph',
				title: 'Обычный текст',
				class: 'ck-heading_paragraph'
			},
			{
				model: 'heading2',
				view: 'h2',
				title: 'Заголовок',
				class: 'ck-heading_heading2'
			},
		]
	},
};

$(document).ready(function(){
	ClassicEditor.create( document.querySelector( '#htm_desc' ), editorConfig )
	.then( newEditor => {
        psy.referatEditor = newEditor;
    } )
	.catch( error => {
	    console.error( error );
	} );
})

// gallery slider
var swiperPopupGallery = new Swiper('.popup-gallery__slider', {
	slidesPerView: 1,
	spaceBetween: 8,
	watchOverflow: true,
	lazy: true,
	pagination: {
		el: '.popup-gallery .swiper-pagination',
		type: 'fraction',
	},
	navigation: {
        nextEl: '.popup-gallery .swiper-arrow--next',
        prevEl: '.popup-gallery .swiper-arrow--prev'
	},
	breakpoints: {
		768: {
			slidesPerView: 1,
			spaceBetween: 16
		},
		1024: {
			slidesPerView: 1,
			spaceBetween: 24
		},
		1440: {
			slidesPerView: 1,
			spaceBetween: 32
		}
	}
});

$('.upload-images__item-link').click(function(e){
	e.preventDefault();
	$('body').addClass('no-scroll');
	$('.popup-gallery-files').addClass('active');
	swiperPopupGallery.slideTo($(this).parent().index(), 0);
});
